import $ from 'jquery';
import moment from 'moment';
import ProfileStore from 'framework/stores/ProfileStore';
import constants from 'lib/constants';
import MobileUtils from 'lib/mobile-utils';
import LtBucksExpiration from 'components/club-info-banner/LtBucksExpiration';
import DayPass from 'components/club-info-banner/DayPassDial';
import selectorConfig from './config.js';
import Framework from 'framework';
import profileStoreIsAvailable from 'lib/profile-store-utils';

let bannerProfileElements = $('.club-info-banner').find('[data-profile]');
let directionsElement = $('a.club-directions');

let initialProfile = profileStoreIsAvailable ? ProfileStore.getInitialData() : null;

function animateGauge(selector, value) {
	var indicator = $(selector).find('path.gauge-indicator');
	// this is the circumference of the circle in pixels
	var circum = 358.192;
	var speed = 2000;
	indicator.animate({'stroke-dashoffset': ((1 - value) * circum) + 'px'}, speed);
}

function checkRange(start, end, val) {
	if(val > end) {
		val = end;
	}
	if(val < start) {
		val = start;
	}
	return val;
}

function timeMessage() {
	var hour = moment().hours();
	var message = '';

	//System displays [ Good morning ] if 2:00AM < Current Time < 12:00PM
	if(hour >= 2 && hour < 12) {
		message = 'Good morning';
	//System displays [ Good afternoon ] if 12:00PM < Current Time < 5:00PM
	}else if(hour >= 12 && hour < 17) {
		message = 'Good afternoon';
	//System displays [ Good evening ] if 5:00PM < Current Time < 2:00AM
	}else if(hour >= 17 || hour < 2) {
		message = 'Good evening';
	}
	return message;
}

function updateContent(profile) {
	if(profile && profile.memberDetails) {
		var valVisitsOf = moment().daysInMonth();

		// get the profile values to display
		var valVisits = profile.memberDetails.clubVisits;
		var valPasses = profile.memberDetails.guestPassBalance;
		var valPassesOf = profile.memberDetails.guestPassTotal;
		var valBucks = profile.memberDetails.ltBucksBalance;

		// gauge expects value between 0 and 1
		var visits = checkRange(0, 1, (valVisits / valVisitsOf));
		var passes = checkRange(0, 1, (valPasses / valPassesOf));
		// set to 0 or 1 if there are bucks or not
		var bucks = valBucks > 0 ? 1 : 0;

		var dayPassDial = new DayPass(profile);
		var dayPasses = 0;

		if(dayPassDial.dayPassUser) {
			dayPassDial.updateDayPass();
			dayPasses = checkRange(0, 1, (dayPassDial.dayPassBalance / dayPassDial.dayPassTotal));

			// if day pass dial is already displayed, replace with latest content
			if($(selectorConfig.dayPassDial).length) {
				$(selectorConfig.dayPassDial).replaceWith(dayPassDial.content);
			}else{
				// add day pass dial to display
				displayDayPassDial(dayPassDial);
			}

			// if day pass has expiration add appropriate tooltip markup
			if(dayPassDial.hasExpiration) {
				addDayPassDialTooltip();
			}
		}

		if(bucks > 0) {
			var ltBucksExpiration = new LtBucksExpiration(profile);
			ltBucksExpiration.updateLtBucksExpiration();
		}

		// display links if the user is logged in
		$('.gauge-link').show();

		$('#gaugeVisits .gauge-value').html(valVisits + '<span class="small"> days</span>');

		$('#gaugePasses .gauge-value').html(valPasses + '<span class="small"> left</span>');
		if(profile.memberDetails.guestPassPeriod && profile.memberDetails.guestPassPeriod === 'Year'){
			$('#gaugePasses .gauge-label').html(' this year');
		}else{
			$('#gaugePasses .gauge-label').html(' this month');
		}

		$('#gaugeBucks .gauge-value').html(valBucks);

		// update the gauges
		setTimeout(function(){
			if(dayPassDial.dayPassUser && dayPassDial.dayPassBalance > 0) {
				animateGauge('#gaugeDayPasses', dayPasses);
			}
			animateGauge('#gaugeVisits', visits);
			animateGauge('#gaugePasses', passes);
			animateGauge('#gaugeBucks', bucks);
		}, 1500);
	}

	// display member message for time part
	$('#memberMessage').html(timeMessage() + ((!profile.memberDetails) ? '' : ', '));

	// show login if the user is not logged in
	if(profile.memberState === constants.memberState.unauthenticated) {
		$('#loginButton').show();
	}
}

// if mobile update directions url to utilize mobile-specific browser
function updateDirectionsHref() {
	// grab directions base url from element drawn by aem
	var baseDirectionsHref = directionsElement.attr('href');

	// grab club coordinates from the base url
	var directionsCoords = baseDirectionsHref.split(constants.defaultDirectionsUrl)[1].split(',');

	// use MobileUtils to determine new base url derived from device type
	var directionsHref = MobileUtils.getDirectionsBaseUrl();

	// apply coordinates to new url with a shift in structure for windows devices to comply with bing
	if(MobileUtils.getMobileDeviceType() === 'windows') {
		directionsHref += directionsCoords[0] + '_' + directionsCoords[1];
		directionsElement.attr('href', directionsHref);
	} else{
		directionsHref += directionsCoords[0] + ',' + directionsCoords[1];
		directionsElement.attr('href', directionsHref);
	}
}

function displayDayPassDial(dial) {
	if(dial.dayPassUserOnly) {
		// day pass only users should not have guest passes and the dial should be hidden
		$('#gaugePasses').hide();
		// for day pass only users the dial should be first in the list
		$('#gaugeVisits').before(dial.content);
	} else{
		// for full access day pass members the dial is second
		$('#gaugeVisits').after(dial.content);
		// move guest passes to end of the list
		$('#gaugePasses').appendTo('#club-info-dashboard .dashboard');
		// update the columns for the club info banner to allow for 4 dials
		if($('#club-information').hasClass('col-md-6')) {
			$('#club-information').removeClass('col-md-6');
			$('#club-information').addClass('col-md-4');
		}
		if($('#club-info-dashboard').hasClass('col-md-6')) {
			$('#club-info-dashboard').removeClass('col-md-6');
			$('#club-info-dashboard').addClass('col-md-8');
		}
	}
}

function addDayPassDialTooltip() {
	$(selectorConfig.dayPassToolTipLink).tooltip({
		html: true,
		constraints: [{to: $('body')[0], attachment: 'together', pin: true }]
	});
	// bind click event
	$(selectorConfig.dayPassToolTipLink).on('shown.bs.tooltip', function () {
		$('.daypass-buy-more-link').click(function(event) {
			event.preventDefault();
			Framework.openPartnerLink(Framework.global.lt.globalPageDrivers.global.dayPassBuyMoreJs, 'SSOID', 'true', 'false', event);
		});
	});
}

if (initialProfile) {
    updateContent(initialProfile);
}


if(directionsElement.length) {
	updateDirectionsHref();
}

var unsubscribeProfile = profileStoreIsAvailable ?
    ProfileStore.listen((profile) => {
        updateContent(profile);
        if (profile.memberState === constants.memberState.authenticated || profile.memberState === constants.memberState.remembered) {
            unsubscribeProfile();
        }
    }) : function() {return;};
